import Vue from 'vue'
import VueMatomo from "vue-matomo"
// import './plugins/vuetify'
import vuetify from './plugins/vuetify'

//import '@fortawesome/fontawesome-free/css/all.css'
//import "./stylus/main.styl"
import App from './App.vue'
import InlineSvg from 'vue-inline-svg'
Vue.component('inline-svg', InlineSvg)

Vue.config.productionTip = false

let pfomtmsiteid = process.env.VUE_APP_SITE_ID

Vue.use(VueMatomo, {
  host: "https://stats.perfumist.fr", // switch this to your account
  siteId: pfomtmsiteid,                          // switch this as well you can find the site id after adding the website to the dashboard.
  trackerFileName: 'matomo',
  enableLinkTracking: true,
  requireConsent: false,
  trackInitialView: true,
  disableCookies: false,
  enableHeartBeatTimer: false,
  heartBeatTimerInterval: 15,
  //router: router,
  debug: false,
  domains: '*.localhost',

})


new Vue({
  vuetify,
  render: h => h(App),
}).$mount('#app')

